import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth as authApi } from '../utils/api';
import AvvisoIscrizioniChiuse from '../components/shared/AvvisoIscrizioniChiuse';
import { CODICE_ISCRIZIONI_CHIUSE, MSG_ISCRIZIONI_CHIUSE } from './iscrizioniChiuse';

// Cantiere Registrazione, Fetta 5c (DEC-067). Atterraggio del link di verifica
// email. Il token sta nel FRAGMENT (#), non in query: così non finisce nei log
// né come Referer (FE-001). Qui si valida il token: se ok, si riceve il
// biglietto e si prosegue col form di adesione (stesso del flusso SSO); il
// biglietto va in sessione, MAI nell'URL (è un lasciapassare a tempo).
function leggiTokenHash() {
  const raw = (window.location.hash || '').replace(/^#/, '');
  return new URLSearchParams(raw).get('token') || '';
}

const MSG_ERRORE = {
  verifica_non_valida: 'Il link di verifica non è valido o è scaduto. Rifai la registrazione.',
  account_gia_registrato: 'Questo account è già registrato. Accedi con la tua email e password.',
  registrazione_chiusa: MSG_ISCRIZIONI_CHIUSE,
};

export default function VerificaEmail() {
  const navigate = useNavigate();
  const [stato, setStato] = useState('verifica');  // 'verifica' | 'errore' | 'chiuse' (DBT-228)
  const [msg, setMsg] = useState('');
  // Il link è USA-E-GETTA: la verifica deve partire UNA sola volta, anche sotto
  // StrictMode (che in sviluppo rimonta l'effetto), o il secondo invio brucerebbe
  // il token e mostrerebbe un errore su un link in realtà valido.
  const partito = useRef(false);

  useEffect(() => {
    if (partito.current) return;
    partito.current = true;

    const token = leggiTokenHash();
    if (!token) {
      setStato('errore');
      setMsg('Questo link di verifica non è valido. Rifai la registrazione.');
      return;
    }
    authApi.registerEmailVerify(token)
      .then((resp) => {
        // Biglietto in sessione (fuori da cronologia e log), poi al form.
        sessionStorage.setItem('registration_ticket', resp.data.registration_ticket);
        sessionStorage.setItem('registration_prefill', JSON.stringify({
          email: resp.data.email || '',
        }));
        navigate('/auth/registrati');
      })
      .catch((err) => {
        const codice = err.response?.data?.codice;
        if (codice === CODICE_ISCRIZIONI_CHIUSE) {
          setStato('chiuse');
          return;
        }
        setStato('errore');
        setMsg(
          MSG_ERRORE[codice] ||
          err.response?.data?.error ||
          'Non siamo riusciti a verificare il link. Riprova tra qualche istante.',
        );
      });
  }, []); // eslint-disable-line

  return (
    <Guscio titolo={stato === 'chiuse' ? 'Iscrizioni in arrivo' : stato === 'errore' ? 'Verifica non riuscita' : 'Verifica in corso'}>
      {stato === 'chiuse' ? (
        <AvvisoIscrizioniChiuse />
      ) : stato === 'errore' ? (
        <div style={{ textAlign: 'center' }}>
          <p style={{ fontSize: 13, color: 'var(--ds-muted)', lineHeight: 1.6, marginBottom: 20 }}>
            {msg}
          </p>
          <button onClick={() => navigate('/auth/registrati-email')} className="gradient-brand" style={btnPrimario}>
            Rifai la registrazione
          </button>
          <button
            onClick={() => navigate('/auth/login')}
            style={{ marginTop: 12, background: 'none', border: 'none', padding: 0, cursor: 'pointer', fontSize: 11, fontWeight: 500, color: 'var(--ds-muted)' }}
          >
            Torna all'accesso
          </button>
        </div>
      ) : (
        <div style={{ textAlign: 'center' }}>
          <div className="gradient-brand" style={{ width: 40, height: 40, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 12px' }}>
            <span style={{ color: 'white', fontWeight: 500, fontSize: 18, fontStyle: 'italic' }}>m</span>
          </div>
          <p style={{ fontSize: 13, color: 'var(--ds-muted)' }}>Stiamo verificando il tuo indirizzo email…</p>
        </div>
      )}
    </Guscio>
  );
}

const btnPrimario = {
  width: '100%', padding: '11px 0', borderRadius: 'var(--radius-base)', border: 'none',
  cursor: 'pointer', fontSize: 13, fontWeight: 500, color: 'white', boxShadow: '0 2px 10px rgba(35,38,47,0.06)',
};

// Guscio grafico condiviso (stessa veste del Login/Registrati).
function Guscio({ titolo, children }) {
  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--chip)', padding: '32px 0' }}>
      <div style={{ width: '100%', maxWidth: 400, padding: '0 16px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginBottom: 32 }}>
          <div className="gradient-brand" style={{ width: 52, height: 52, borderRadius: 'var(--radius-card)', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12, boxShadow: '0 6px 18px rgba(35,38,47,0.08)' }}>
            <span style={{ color: 'white', fontWeight: 500, fontSize: 22, fontStyle: 'italic' }}>m</span>
          </div>
          <div style={{ fontSize: 20, fontWeight: 500, color: 'var(--ink)', fontFamily: 'var(--font-display)' }}>mAIstro</div>
        </div>
        <div style={{ background: 'var(--ds-bg)', borderRadius: 'var(--radius-card)', border: '1px solid var(--ds-border)', padding: 28, boxShadow: '0 6px 18px rgba(35,38,47,0.08)' }}>
          <h2 style={{ fontSize: 16, fontWeight: 500, color: 'var(--ink)', marginTop: 0, marginBottom: 16, fontFamily: 'var(--font-display)' }}>{titolo}</h2>
          {children}
        </div>
      </div>
    </div>
  );
}
